import React from "react";
import { StyledContainer } from "./styles";
import Card from "..";
import macInstructions from "../../../../assets/canvas-mac-instructions.png";
import pcInstructions from "../../../../assets/canvas-pc-instructions.png";
import { getOS } from "../../../../Utils";

export default function InstructionsCard({
  x,
  y,
  width,
  height,
  id,
  selected,
  type,
  zoom,
  generating,
  index,
  autoHeight,
}) {

  const image = getOS() === "mac" ? macInstructions : pcInstructions;

  return (
    <Card
      x={x}
      y={y}
      content={""}
      width={width}
      height={height}
      id={id}
      selected={selected}
      type={type}
      zoom={zoom}
      generating={generating}
      index={index}
      generatable={false}
      naked={true}
      resizable={false}
      autoHeight={autoHeight}
    >
      <StyledContainer>
        <img
          draggable="false"
          src={image}
        />
      </StyledContainer>
    </Card>
  );
}
